import React from 'react';
import styled, { keyframes } from 'styled-components';
import LogoOval from "../../Icon/LogoOval";
import colors from "../../../colors/index";
var bounce = keyframes(["from{transform:scale(1);}25%{transform:scale(0.7);}50%,to{transform:scale(1);}"]);
var Dot = styled(LogoOval).attrs({
  width: '11px',
  height: '11px'
}).withConfig({
  displayName: "Dot",
  componentId: "l8eqzu-0"
})(["&:nth-child(1){animation:", " 1.2s linear 0s infinite;}&:nth-child(2){animation:", " 1.2s linear 0.15s infinite;}&:nth-child(3){animation:", " 1.2s linear 0.3s infinite;}"], bounce, bounce, bounce);
var DotWrapperStyled = styled.div.withConfig({
  displayName: "Dot__DotWrapperStyled",
  componentId: "l8eqzu-1"
})(["position:absolute;left:50%;transform:translateX(-50%);right:0;bottom:0;top:0;display:flex;justify-content:center;align-items:center;width:100%;min-width:30px;"]);
export var DOT_TEST_ID = 'dot';
export var DotWrapper = function DotWrapper(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors.white : _ref$color,
      loader = _ref.loader;
  return React.createElement(DotWrapperStyled, null, loader ? loader(color) : React.createElement(React.Fragment, null, React.createElement(Dot, {
    color: color,
    "data-testid": DOT_TEST_ID
  }), React.createElement(Dot, {
    color: color,
    "data-testid": DOT_TEST_ID
  }), React.createElement(Dot, {
    color: color,
    "data-testid": DOT_TEST_ID
  })));
};